import {
  createContext,
  useContext,
  useMemo,
  type ReactNode
} from 'react'

import { getCurrentTenantSlug } from './current'

export type TenantContextValue = {
  /** Canonical event slug: the edge-resolved cookie, or the host in dev. */
  eventSlug: string | null
  /** Same as eventSlug. */
  tenantSlug: string | null
  /**
   * @deprecated Use `eventSlug`. Same string slug — not `DigitalProduct.id`.
   */
  digitalProductId: string | null
  hasTenant: boolean
}

const TenantContext = createContext<TenantContextValue | null>(null)

export function TenantProvider({ children }: { children: ReactNode }) {
  const value = useMemo<TenantContextValue>(() => {
    const tenantSlug = getCurrentTenantSlug()

    return {
      eventSlug: tenantSlug,
      tenantSlug,
      digitalProductId: tenantSlug,
      hasTenant: Boolean(tenantSlug)
    }
  }, [])

  return (
    <TenantContext.Provider value={value}>{children}</TenantContext.Provider>
  )
}

export function useTenant(): TenantContextValue {
  const ctx = useContext(TenantContext)

  if (!ctx) {
    throw new Error('useTenant must be used within TenantProvider')
  }

  return ctx
}

export function useTenantOptional(): TenantContextValue | null {
  return useContext(TenantContext)
}
